export const getAbsoluteUrl = (relativeUrl) => {
    if (!relativeUrl || relativeUrl.length === 0) {
        return window.location.origin;
    }
    return window.location.origin + (relativeUrl[0] !== '/' ? '/' : '') + relativeUrl;
};
